export default __webpack_public_path__ + "static/media/slide2.0dff0b1a.webp";